export function humanCurrency(number, decimals = 0) {
    if (number > 1000000) { // £9m
        if (decimals === 0) {
            decimals = 2;
        }
        return '£' + (number / 1000000).toFixed(decimals) + 'm';
    }
    else if (number > 1000) { // £999k
        return '£' + (number / 1000).toFixed(decimals) + 'k';
    }
    return '£' + Number(number).toFixed(decimals); // £999
}
